import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import Logo from 'dpl/components/Logo';

import useScrollTrigger from '../hooks/useScrollTrigger';

export default function StickyHeader() {
  const scrollTrigger = useScrollTrigger();
  const [elevated, setElevated] = useState(false);

  function handleScroll() {
    setElevated(!scrollTrigger && window.scrollY > 16);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={classnames('StickyHeader', { elevated })}>
      <section>
        <div className="container flex justify-between items-center pv4">
          <a
            href="/"
            className="Header__logo dib mw-100 primary"
            aria-label="homepage"
          >
            <Logo />
          </a>
          <button
            type="button"
            className="button button--primary"
            data-analytics="true"
            data-action="price-check"
            data-view-feature="check_your_price_button"
            data-view-feature-location="header"
          >
            Check your prices
          </button>
        </div>
      </section>
    </header>
  );
}
